import * as api from '../../../clients/vorlagen';

import {Action} from '@ngrx/store';

export const POST_UPDATE_VORLAGEN_MANDANT_OPTIONS = '[VorlagenModul] PostUpdateVorlagenMandantOptions laden';
export const POST_UPDATE_VORLAGEN_MANDANT_OPTIONS_AUSFUEHREN = '[VorlagenModul] PostUpdateVorlagenMandantOptions ausführen';
export const POST_UPDATE_VORLAGEN_MANDANT_OPTIONS_ERFOLGREICH = '[VorlagenModul] PostUpdateVorlagenMandantOptions laden erfolgreich';
export const POST_UPDATE_VORLAGEN_MANDANT_OPTIONS_FEHLER = '[VorlagenModul] PostUpdateVorlagenMandantOptions Ladefehler';
export const POST_UPDATE_VORLAGEN_MANDANT_OPTIONS_NICHT_AUSGEFUEHRT = '[VorlagenModul] PostUpdateVorlagenMandantOptions nicht ausgeführt (evtl. Offline)';


export class PostUpdateVorlagenMandantOptionsAction implements Action {
    readonly type = POST_UPDATE_VORLAGEN_MANDANT_OPTIONS;
        constructor(public vorlagenMandantOptions: api.VorlagenMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateVorlagenMandantOptionsAusfuehrenAction implements Action {
    readonly type = POST_UPDATE_VORLAGEN_MANDANT_OPTIONS_AUSFUEHREN;
        constructor(public vorlagenMandantOptions: api.VorlagenMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateVorlagenMandantOptionsErfolgreichAction implements Action {
    readonly type = POST_UPDATE_VORLAGEN_MANDANT_OPTIONS_ERFOLGREICH;
        constructor(public vorlagenMandantOptions: api.VorlagenMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateVorlagenMandantOptionsFehlerAction implements Action {
    readonly type = POST_UPDATE_VORLAGEN_MANDANT_OPTIONS_FEHLER;
        constructor(public payload: any, public vorlagenMandantOptions: api.VorlagenMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateVorlagenMandantOptionsNichtAusgefuehrtAction implements Action {
    readonly type = POST_UPDATE_VORLAGEN_MANDANT_OPTIONS_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VorlagenCommandUpdateVorlagenMandantOptionsActions =
    PostUpdateVorlagenMandantOptionsAction
    | PostUpdateVorlagenMandantOptionsAusfuehrenAction
    | PostUpdateVorlagenMandantOptionsErfolgreichAction
    | PostUpdateVorlagenMandantOptionsFehlerAction
    | PostUpdateVorlagenMandantOptionsNichtAusgefuehrtAction
    ;
